import React, { useEffect, useState } from 'react';
import { getNameClient } from '../../helpers/nameClient';
import { Row } from 'reactstrap';
import './summaryImport.scss';
import { useDispatch, useSelector } from 'react-redux';
import { Container } from 'reactstrap';
import Filters from '../../components/Common/Filters/filters';
import { getDynamicAttrUpdated } from '../../helpers/tools_helper';
import { ITable } from '../../components/Common/iComponents/iTable/ITable';
import moment from 'moment';
import { IPopUp } from '../../components/Common/iComponents/iPopUp/IpopUp';
import IForm from './IForm';
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import { getIdFromObject } from '../../helpers/tasks_helper';
import { useLoadingModal } from '../../common/hooks/useLoading';
import usePageTitle from '../../common/hooks/usePageTitle';
import { getSummaryImport, getSummaryImportFilters } from '../../store/summaryImport/actions';

const SummaryImport = (props:any) => {
  const dispatch = useDispatch();
    const { listData, CountItems, filterItems, loading } = useSelector((state: any) => state.SummaryImport);
    const [pagination, setPagination] = useState<{
        sizePerPage: number;
        page: number;
    }>({
        sizePerPage: 50,
        page: 1,
    });
    const [popUpState, setpopUpState] = useState(false);
    const [updateState, setUpdateState] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});
    const [isFirstRun, setIsFirstRun] = useState(true);
    const [visibleClientId,setVisibleClientId] = useState(false);
    const [title, setTitle] = useState('');

    const PageTitleTraceabilities = usePageTitle(props.location.pathname);

    const currentDate = new Date();
    const { hideProgress, showProgress } = useLoadingModal();

    const [filters, setFilters] = useState({
        from: moment(currentDate).format('YYYY-MM-DD'),
        to: moment(currentDate).format('YYYY-MM-DD'),
        order: "{'createdAt' : 'DESC'}",
        dynamicFilter: '',
    });

    useEffect(() => {

        let user;
        const getAuthUser = localStorage.getItem('authUser');
        if (getAuthUser) {
            user = JSON.parse(getAuthUser);
        }

        if(user?.ROL_ID == 19){
            setVisibleClientId(true);
          }
    }, []);

    useEffect(() => {
        if (isFirstRun) {
          const filters = JSON.parse(localStorage.getItem("filterOperation") || "{}");
          if (filters[groupName]) {
            handleActionOnSearch(filters[groupName]);
          }
          setIsFirstRun(false);
        } else {
           dispatch(getSummaryImport({ pagination, filters }));
        }
      }, [dispatch, filters, pagination, isFirstRun]);

    // Los filtros dependen del rango From/To: se vuelven a pedir cuando cambia.
    useEffect(() => {
        dispatch(getSummaryImportFilters({ from: filters.from, to: filters.to }));
    }, [dispatch, filters.from, filters.to]);

    const handleTableSort = (type :any, { sortField, sortOrder }:any) => {
        setFilters( {...filters,
            order: `{'${sortField ?? 'createdAt'}' : '${sortOrder.toUpperCase()}'}` 
        })
    }
    useEffect(() => {
        if (loading) {
            showProgress();
        } else {
            hideProgress();
        }
    }, [hideProgress, loading, showProgress]);

    const columns = [
        {
            text: 'Date',
            visibleInTable: true,
            dataField: 'createdAt',
        },
        {
            text: 'Status',
            visibleInTable: true,
            dataField: 'status',
        },
        {
            text: 'Message',
            visibleInTable: true,
            dataField: 'message',
        },
        {
            text: 'Result XML',
            visibleInTable: true,
            dataField: 'resultXML',
        },
        {
            text: 'Task Description',
            visibleInTable: true,
            formatter: (cellContent: any, log: any) => <>{log?.iTask?.descripcion ?? "Non-TaskId"}</>
        },
        {
            text: 'Number',
            visibleInTable: true,
            dataField: 'Number',
        },
        {
            text: 'Entity',
            visibleInTable: true,
            dataField: 'entity',
        },
        {
            text: 'Identificator',
            visibleInTable: true,
            dataField: 'identificator',
        },
        {
            text: 'Client ID',
            visibleInTable: visibleClientId,
            dataField: 'clientId',
        },
        {
            text: 'Task ID',
            visibleInTable: true,
            dataField: 'taskId',
        },
        {
            text: 'JSON',
            visibleInTable: true,
            dataField: 'text',
        },
    ];

    const handlePaginationChange = (newState: any) => {
        setPagination(newState);
    };

    const handleActionOnSearch = (data: any) => {
        if (data.taskId) {
            data.taskId.forEach((t: any) => {
                const id = getIdFromObject(t);
                t.value = id;
            });
        }
        if (data.clientId) {
            data.clientId.forEach((c: any) => {
                const id = getIdFromObject(c);
                c.value = id;
            });
        }
        const filterString = getDynamicAttrUpdated(data);
        setFilters((prevFilters) => ({
            ...prevFilters,
            order: filters.order,
            dynamicFilter: filterString,
            from: data.from,
            to: data.to,
        }));
    };

    const onPopUpState = () => {
        setpopUpState(!popUpState);
    };
    const handleActionOnRowClick = (row: any) => {
        setTitle(`${row.entity} - ${row.Number}`);
        setSelectedRow(row);
    };

    const groupName = 'SummaryImportList';
  return (
    <React.Fragment>
            <div className="page-content">
                {/* <div id="menuColumn"></div> */}
                <PageTitle>
                    <title>{PageTitleTraceabilities.replace(/-/g, ' ')} | {getNameClient()}</title>
                </PageTitle>
                <Container fluid>
                    <Row>
                        <Filters groupName={groupName} onSearchClicked={handleActionOnSearch} filterItems={filterItems} />
                    </Row>
                    <Row>
                        <Row>
                            <ITable
                                remote={true}
                                CountItems={CountItems}
                                handlerPaginationState={handlePaginationChange}
                                data={listData}
                                fields={columns}
                                tableColumns={columns}
                                headerColorT="bg-primary text-white"
                                actionOnRowClick={handleActionOnRowClick}
                                handlePopUpState={onPopUpState}
                                groupName={groupName}
                                handleTableSort={handleTableSort}
                            />
                        </Row>
                    </Row>
                </Container>
            </div>
            <IPopUp
                stateAdd={popUpState}
                switchStateAdd={setpopUpState}
                stateUpdate={updateState}
                switchStateUpdate={setUpdateState}
                modalTitleAdd={title}
                modaleTitleUpdate={'Summary Import'}
                icon="shopping-bag"
                colorHeaderPop={'#101340'}
            >
                <IForm selectedRow={selectedRow} />
            </IPopUp>
        </React.Fragment>
  )
}

export default SummaryImport